<template>
  <div class="submission-line">
    <div class="submission-line-header" @click="vLoadDetails()">
      <div class="submission-line-cell">
        <span>{{ lineData.tnsoum }}</span>
      </div>
      <div  class="submission-line-cell">
        <span>{{ $dateformat(lineData.tdate_soum) }}</span>
      </div>
      <div class="submission-line-cell">
        <span>{{ lineData.tlib_type }}</span>
      </div>
      <div class="submission-line-cell">
        <span>{{ lineData.tncde }}</span>
      </div>
      <div class="submission-line-cell">
        <span>{{ lineData.trefc }}</span>
      </div>
      <div class="submission-line-cell">
        <span>{{ lineData.tmod }}</span>
      </div>
      <div class="submission-line-cell">
        <span>{{ lineData.tcol_tmarq }}</span>
      </div>
      <div class="submission-line-cell">
        <span>{{ lineData.tlib_status }}</span>
      </div>
      <div class="submission-line-cell">
        <span>{{ $dateformat(lineData.tdelai_soum) }}</span>
      </div>
      <div class="submission-line-cell">
        <span>{{ $dateformat(lineData.tdate_acc) }}</span>
      </div>
    </div>
    <div class="submission-line-details" v-show="load_details">
      <div class="grid-row">
        <div class="column">
          <div class="details-block">
            <span class="details-title">{{$_('details')}}</span>
            <span>{{$_('color')}} : <span>{{lineData.tcol_tmarq}}</span></span>
            <span>{{$_('sample_number')}} : <span>{{lineData.tnb_ech}}</span></span>
            <span>{{$_('quantity')}} : <span>{{lineData.tqte}}</span></span>
          </div>
        </div>
        <div class="column">
          <div class="details-block">
            <span class="details-title">{{$_('time_limit')}}</span>
            <span>{{$_('submission_completion_date')}} : <span>{{$dateformat(lineData.tdate_real)}}</span></span>
            <span>{{$_('submission_date')}} : <span>{{$dateformat(lineData.tdate_soum)}}</span></span>
          </div>
        </div>
      </div>
      <div class="grid-row">
        <div class="column">
          <span class="array-title">{{$_('submission_history')}}</span>
          <SubmissionHistory :tnsoum="lineData.tnsoum" :load="load_details" />
        </div>
      </div>
      <SubmissionForm v-if="lineData.tstatus === 'E'" :line="lineData.tnsoum" :tnb_ech="lineData.tnb_ech" />
    </div>        
  </div>
</template>

<script>

import SubmissionHistory from '@/modules/soumission/components/SubmissionHistory';
import SubmissionForm from '@/modules/soumission/components/SubmissionForm';

export default {
  props: ['dataline', 'index'],
  name:'SubmissionLine',
  components: {
    SubmissionHistory,
    SubmissionForm
  },
  data() {
    return {
      lineData: {
        tnsoum: this.$props.dataline.TNSOUM,
        tdate_soum: this.$props.dataline.TDATE_SOUM,
        tlib_type: this.$props.dataline.TLIB_TYPE,
        tncde: this.$props.dataline.TNCDE,
        trefc: this.$props.dataline.TREFC,
        trefc_label: this.$props.dataline.TREFC_LABEL,
        tstatus: this.$props.dataline.TSTATUS,
        tlib_status: this.$props.dataline.TLIB_STATUS,
        tdelai_soum: this.$props.dataline.TDELAI_SOUM,
        tdate_acc: this.$props.dataline.TDATE_ACC,
        tqte: this.$props.dataline.TQTE+' '+this.$props.dataline.TUNIT_QTE,
        tdate_real: this.$props.dataline.TDATE_REAL,
        tcol_tmarq: this.$props.dataline.TCOL+'-'+this.$props.dataline.TMARQ,
        tnb_ech: this.$props.dataline.TNB_ECH,
        tmod: this.$props.dataline.TMOD, 
      },
      load_details: false
    }
  },
  methods: {
    vLoadDetails() {
      this.load_details = !this.load_details;
    }
  }
}
</script>

<style scoped>
.submission-line-header {
  display: flex;
  border: solid 1px #E9E9E9;
  margin-top: 10px;
  transition: all .3s;
}
.submission-line-cell {
  display: flex;
  width: calc(100% / 10);
  justify-content: center;
  padding: 25px 0px;
  align-items: center;
  text-align: center;
}
.submission-line-cell span {
  color:#585858;
  font-size: var(--fz-md);
  transition: all .3s;
}
.submission-line:hover {
  background-color: #F5F5F5;
  cursor: pointer;
}
.submission-line:hover .submission-line-cell span {
  color: #8B8B8B;
}
.details-block {
  flex-direction: column;
  display: flex;
  color: #585858
}
.details-title {
  font-weight: bold; 
  margin-bottom: 15px;
  color: rgb(142, 141, 141);
}
.submission-line-details {
  background-color: #f9f8f8;
  border: solid 1px rgb(230, 230, 230);
  border-top: 0px;
}
.array-title {
  margin: 0px 0px 15px;
  display: block;
  color: #8e8d8d;
  font-weight: bold;
}
</style>